import { CustomValueImport } from "PFTypes";
import React, { createContext, PropsWithChildren, useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { ImportModalPage } from "../constants/import_modal_page";

type ImportSkillsModalContextData = {
  currentPage: ImportModalPage;
  setCurrentPage: (newPage: ImportModalPage) => void;
  search?: string;
  setSearch: (term: string) => void;
  importData: CustomValueImport | null;
  setImportData: (importData: CustomValueImport) => void;
};

const ImportSkillsModalContext = createContext<ImportSkillsModalContextData | null>(null);

export const ImportSkillsModalContextProvider = ({
  children,
  initialPage
}: PropsWithChildren<{ initialPage?: ImportModalPage }>): JSX.Element => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState<ImportModalPage>(initialPage || ImportModalPage.Upload);
  const [search, setSearch] = useState<string>("");
  const [importData, setImportData] = useState<CustomValueImport | null>(null);

  const openPage = (newPage: ImportModalPage) => {
    setCurrentPage(newPage);
    history.push(`/admin/skills_management/import/${newPage}`);
  };

  return (
    <ImportSkillsModalContext.Provider
      value={{
        currentPage,
        setCurrentPage: openPage,
        search,
        setSearch,
        importData,
        setImportData
      }}
    >
      {children}
    </ImportSkillsModalContext.Provider>
  );
};

export const useImportSkillsModalContext = () => {
  const context = useContext(ImportSkillsModalContext);

  if (!context) {
    throw new Error("useImportSkillsModalContext must be used within a ImportSkillsModalContextProvider");
  }

  return context;
};
